import React, {useState, useEffect } from "react";
import "./page_3_stallions.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrophy, faBirthdayCake} from '@fortawesome/fontawesome-free-solid'
import { faHorse, faHorseHead, faTree ,faMedal } from '@fortawesome/free-solid-svg-icons';
import {Link} from "react-router-dom";
import { useTranslation } from 'react-i18next';



function Page_3_stallions(){

    const { t } = useTranslation();
    const [data, setData] = useState(null);
    useEffect(()=>{
        fetch("/data.json").then(response => response.json()).then(data=> setData(data)).catch(error => console.error("cannot load data in file data.json : ",error));
    } ,[]);

    if(!data){
        return(<div>Is loading...</div>)
    }

    const filtredData = data.items.filter(item=> item.isStallion === true && item.isDisplayed === true );

    return(

        //import ownerPicture_2 from "../../../data/appData/appImages/owner/owner2.jpg" ;
        <div className="page3_stallions_content">
            <div className="float-start w-100 text-center mt-3 fw-bold fs-5 mb-3">{t("stallions")}</div>
            
            
                <Container className="page3_stallion_container ">
                    {filtredData.map(function(champion, index ){
                        if( champion.category === "purSang" && champion.isStallion === true && champion.isDisplayed === true){
                               
                             
                            if(index % 2 === 0  ){
                                return(

                                    <Row className="row_container">
                                        <Col xs={12} sm={6}  md={6} lg={6} className="page3_stallion_col1">
                                            <Link className="text-decoration-none" to={`stallionDetail/${champion.id}`}>
                                                <img  className="championPicture" src={"/data/appData/appImages/stallions_picture/" + champion.id+".jpg"} alt="" onContextMenu={(e)=> e.preventDefault()}/>
                                            </Link>
                                        </Col>
                                        <Col xs={12} sm={6}  md={6} lg={6} className="page3_stallion_col2  ">

                                        <StallionInfo  champion={champion} ></StallionInfo>
                                        </Col>
                                    </Row>
                                )
                            }else{
                                return(

                                    <Row className="row_container">
                                        <Col xs={0} sm={6}  md={6} lg={6} xsHidden smHidden className="page3_stallion_col2 d-none d-lg-block d-md-block d-sm-block d-xs-none  hidden-xs">
                                            

                                            <StallionInfo  champion={champion} ></StallionInfo>    

                                        </Col>
                                        <Col xs={12} sm={6}  md={6} lg={6} className="page3_stallion_col1">
                                            <Link className="text-decoration-none" to={`stallionDetail/${champion.id}`}>
                                                <img  className="championPicture" src={"/data/appData/appImages/stallions_picture/" + champion.id+".jpg"} alt="" onContextMenu={(e)=> e.preventDefault()}/>
                                            </Link>
                                        </Col>
                                        <Col xs={12} sm={0}  md={0} lg={0} className="page3_stallion_col1 d-non d-xs-block d-lg-none d-md-none d-sm-none">
                                            <StallionInfo  champion={champion} ></StallionInfo>
                                        </Col>
                                    </Row>
                                )


                            }
                                        

                                    
                                
                            
                        }

                    })}

                </Container>
                
            

        </div>
        

    )

    
    function StallionInfo(props){
        let champion = props.champion ;
        return(
            <div>
                <div className="divMarg d-none d-lg-block d-md-block d-sm-block d-xs-none "></div>
                <div className="page_3_stallion_para_div">
                    <Link className="text-decoration-none" to={`stallionDetail/${champion.id}`}>
                        <p className="page_3_stallion_para">
                            <span className="fs-5 fw-bold">{  champion.name}</span><br></br>
                            { champion.borne_date }<br></br>

                            { champion.father} x { champion.mother }

                        </p>  
                    </Link>
                </div>   
            </div> 
        )
    }
    

}

export default Page_3_stallions